import {
  doc,
  getDoc,
  onSnapshot,
  serverTimestamp,
  setDoc,
} from 'firebase/firestore';
import { db } from './firebase';
import type { FeatureFlagOverride } from '../types/featureFlags';

const ADMIN_CONFIG_COLLECTION = 'admin_config';
const FEATURE_FLAGS_DOC_ID = 'feature_flags';

function featureFlagsDocRef() {
  return doc(db, ADMIN_CONFIG_COLLECTION, FEATURE_FLAGS_DOC_ID);
}

export async function getFeatureFlagOverrides(): Promise<
  Record<string, FeatureFlagOverride>
> {
  const snapshot = await getDoc(featureFlagsDocRef());
  if (!snapshot.exists()) return {};
  const data = snapshot.data() as { flags?: Record<string, FeatureFlagOverride> };
  return data.flags || {};
}

export async function setFeatureFlagOverride(
  id: string,
  enabled: boolean,
  userId: string,
): Promise<void> {
  await setDoc(
    featureFlagsDocRef(),
    {
      flags: {
        [id]: {
          enabled,
          lastChangedAt: serverTimestamp(),
          lastChangedBy: userId,
        },
      },
    },
    { merge: true },
  );
}

export function subscribeToFeatureFlagOverrides(
  callback: (overrides: Record<string, FeatureFlagOverride>) => void,
): () => void {
  return onSnapshot(featureFlagsDocRef(), (snapshot) => {
    if (!snapshot.exists()) {
      callback({});
      return;
    }
    const data = snapshot.data() as {
      flags?: Record<string, FeatureFlagOverride>;
    };
    callback(data.flags || {});
  });
}
